import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { TitleM } from "../../../components/atoms/Typography";
import { ContentWrapper } from "../../../components/ContentWrapper";
import { CoreTable } from "../../../components/organisms/CoreTable";
import { useAppSelector } from "../../../hooks/redux";
import { setPageSize, setSearchParam } from "../../../redux/reducers/filter";
import { useColumns } from "./table/columns";
import { useGetData } from "./table/data";
import { useActionButtons } from "./table/actionButtons";
import { AuditDetailsModal } from "./AuditDetailsModal";

export default function AuditLogs() {
  const dispatch = useDispatch();
  const [, setPage] = useState(0);
  const globalUserFilter = useAppSelector((state) => state.filter);
  const reshapedGlobalUserFilter = useMemo(() => {
    const reshapedFilter =
      (globalUserFilter["auditLog"] &&
        JSON.parse(JSON.stringify(globalUserFilter["auditLog"]))) ??
      {};
    if (globalUserFilter["auditLog"]) {
      Object.keys(globalUserFilter["auditLog"]).forEach((key) => {
        const filter = globalUserFilter["auditLog"]?.[key];
        if (typeof filter === "object") {
          if (!filter?.name && reshapedFilter && key.includes(".")) {
            delete reshapedFilter[key];
            reshapedFilter[key.split(".")[0]] = {
              name: filter,
            };
          }
        }
      });
      return reshapedFilter;
    }
  }, [globalUserFilter]);
  const [, setFilterValues] = useState(reshapedGlobalUserFilter ?? {});

  useEffect(() => {
    setFilterValues(reshapedGlobalUserFilter ?? {});
  }, [reshapedGlobalUserFilter]);

  const filterString = useMemo(() => {
    const filters: string[] = [];
    Object.entries(reshapedGlobalUserFilter ?? {}).forEach(([key, value]) => {
      if (value && typeof value === "object" && "name" in value) {
        filters.push(`${key}=${encodeURIComponent((value as any).name)}`);
      } else if (value) {
        filters.push(`${key}=${encodeURIComponent(String(value))}`);
      }
    });
    return filters.join("&");
  }, [reshapedGlobalUserFilter]);

  const { config } = useGetData(filterString ?? "");
  const { columns, selectedAuditLog, setSelectedAuditLog } = useColumns();
  const { openFilters, setOpenFilters } = useActionButtons();
  const { loading: isLoading } = config;
  const data: any = config?.data;
  const totalAmountOfRecords = data?.total || 0;
  const actionRightButtons: any[] = [];

  useEffect(() => {
    dispatch(
      setPageSize({
        auditLogControl: { pageSize: config.asyncConfig.pageSize ?? 50 },
      })
    );
  }, [config?.asyncConfig?.pageSize, dispatch]);

  useEffect(() => {
    dispatch(
      setSearchParam({
        auditLogControl: { search: config?.asyncConfig?.facets?.search },
      })
    );
  }, [config?.asyncConfig?.facets?.search, dispatch]);

  useEffect(() => {
    config.asyncConfig.onPaginationChange({
      pageSize: Number(globalUserFilter.auditLogControl?.pageSize ?? 50),
      pageIndex: 0,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ContentWrapper>
        <TitleM style={{ margin: "1rem 0" }}>Audit Logs</TitleM>
        <CoreTable
          key={filterString}
          tableType="auditLog"
          columns={columns}
          isLoading={isLoading}
          setPage={setPage}
          totalAmountOfRecords={totalAmountOfRecords}
          searchByPage={true}
          setFilterValues={setFilterValues}
          openFilters={openFilters}
          setOpenFilters={setOpenFilters}
          actionRightButtons={actionRightButtons}
          actionRightAccessories={null}
          pageSize={Number(globalUserFilter.auditLogControl?.pageSize ?? 50)}
          {...config}
        />
      </ContentWrapper>
      {selectedAuditLog && (
        <AuditDetailsModal
          isOpen={true}
          onClose={() => setSelectedAuditLog(null)}
          metadata={selectedAuditLog.metadata}
          message={selectedAuditLog.message}
        />
      )}
    </>
  );
}
